import { API } from 'src/constants/api';

import { axiosInterceptor } from './interceptors';

export const updateSetting = async (data: any) => {
    const response = await axiosInterceptor.put(API.USER.UPDATE_USER_SETTINGS, data);

    return response;
};
